import Layout from '@layout/Index'

export const finance = [
  {
    path: '/finance',
    component: Layout,
    children: [
      {
        path: 'batch-withdraw-table',
        component: () => import(/* webpackChunkName: "batch-withdraw-table" */ './pages/BatchWithdrawTable.vue'),
        name: '批量提现列表',
        meta: {
          title: '批量提现列表',
        },
      },
      {
        path: 'bank-withdraw-table',
        component: () => import(/* webpackChunkName: "bank-withdraw-table" */ './pages/BankWithdrawTable.vue'),
        name: '银行卡提现批次管理',
        meta: {
          title: '银行卡提现批次管理',
          type: 1,
        },
      },
      {
        path: 'alipay-withdraw-table',
        component: () => import(/* webpackChunkName: "bank-withdraw-table" */ './pages/BankWithdrawTable.vue'),
        name: '支付宝提现批次管理',
        meta: {
          title: '支付宝提现批次管理',
          type: 2,
        },
      },
      {
        path: 'wx-withdraw-table',
        component: () => import(/* webpackChunkName: "bank-withdraw-table" */ './pages/BankWithdrawTable.vue'),
        name: '微信提现批次管理',
        meta: {
          title: '微信提现批次管理',
          type: 3,
        },
      },
      {
        path: 'batch-withdraw-option-table',
        component: () => import(/* webpackChunkName: "batch-withdraw-option-table" */ './pages/BatchWithdrawOptionTable.vue'),
        name: '批量提现操作列表',
        meta: {
          title: '批量提现操作列表',
        },
      },
      {
        path: 'withdraw-wx-table',
        component: () => import(/* webpackChunkName: "finance-withdraw-wx-table" */ './pages/WithdrawTable.vue'),
        name: '微信提现管理',
        meta: {
          title: '微信提现管理',
        },
      },
      {
        path: 'withdraw-alipay-table',
        component: () => import(/* webpackChunkName: "finance-withdraw-alipay-table" */ './pages/WithdrawTable.vue'),
        name: '支付宝提现管理',
        meta: {
          title: '支付宝提现管理',
        },
      },
      {
        path: 'withdraw-bank-table',
        component: () => import(/* webpackChunkName: "finance-withdraw-bank-table" */ './pages/WithdrawTable.vue'),
        name: '银行卡提现管理',
        meta: {
          title: '银行卡提现管理',
        },
      },
      {
        path: 'batch-withdraw-detail/:type/:id',
        component: () => import(/* webpackChunkName: "finance-withdraw-detail" */ './pages/WithdrawBatchDetail.vue'),
        name: '提现批次详情',
        meta: {
          title: '提现批次详情',
        },
      },
      {
        path: 'ajx/project/table',
        component: () => import(/* webpackChunkName: "finance-ajx-project-table" */ '../customer-project/pages/AjxProjectTable.vue'),
        name: '爱绩效项目审核',
        meta: {
          title: '爱绩效项目审核',
        },
      },
      {
        path: 'inactive-user-table',
        component: () => import(/* webpackChunkName: "inactive-user-table" */ './pages/InactiveUserTable.vue'),
        name: '不活跃用户',
        meta: {
          title: '不活跃用户',
        },
      },
    ],
  },
]



// WEBPACK FOOTER //
// ./src/views/finance/finance.route.js